import { datadogLogs } from '@datadog/browser-logs';

import env from '~/env.public';

interface Logger {
  debug(message: string, context?: object): void;
  info(message: string, context?: object): void;
  warn(message: string, context?: object): void;
  error(message: string, context?: object): void;
}

const logger: Logger = {
  info: (...args) => {
    if (env.ENABLE_CONSOLE_LOGS) {
      console.log(...args);
    }
    datadogLogs.logger.info(...args);
  },
  debug: (...args) => {
    if (env.ENABLE_CONSOLE_LOGS) {
      console.log(...args);
    }
    datadogLogs.logger.debug(...args);
  },
  warn: (...args) => {
    if (env.ENABLE_CONSOLE_LOGS) {
      console.warn(...args);
    }
    datadogLogs.logger.warn(...args);
  },
  error: (...args) => {
    if (env.ENABLE_CONSOLE_LOGS) {
      console.error(...args);
    }
    datadogLogs.logger.error(...args);
  },
};

export default logger;
